import tw from "tailwind-styled-components";

const BrandTitle = tw.div`
	absolute
	top-[37px]
	left-[128px]
	cursor-pointer

	max-lg:left-[50%]
	max-lg:translate-x-[-50%]
`;

export { BrandTitle };
